import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ScrollFloatProps {
  children: ReactNode;
  className?: string;
  /** Starting scale (1 = no zoom in) */
  scaleFrom?: number;
  /** Ending scale */
  scaleTo?: number;
  /** Y translation */
  yFrom?: number;
  yTo?: number;
}
export function ScrollFloat({
  children,
  className = '',
  scaleFrom = 0.85,
  scaleTo = 1,
  yFrom = 60,
  yTo = 0
}: ScrollFloatProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'center center']
  });
  const scale = useTransform(scrollYProgress, [0, 1], [scaleFrom, scaleTo]);
  const y = useTransform(scrollYProgress, [0, 1], [yFrom, yTo]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [0, 1]);
  return <motion.div ref={ref} style={{
    scale,
    y,
    opacity
  }} className={className} data-id="element-233">
      {children}
    </motion.div>;
}